import * as React from 'react'
import { connect } from 'react-redux'
import { preHideNotification } from '../../actions/notification'
import { SearchField } from '../answers/searchfield'
import linkifyHtml from 'linkifyjs/html'
import { navigateTo, changeNavigationStack } from '../../actions/navigation'
import {
  userIdFromAnswersHubSelector,
  formIdFromAnswersHubSelector,
  notificationHubSelector
} from '../../selectors/hub'
import { HubItem } from '../../reducers/hub'
import { createHubItemId } from '../../lib/utils'

import '../../sass/online/answersnotification.scss'
import { RootState } from '../../types/rootstate'
import { resizingComponent } from '../resizingcomponent'
import { strings } from '../../lib/localization'

const LINKIFY_OPTIONS = {
  nl2br: true
}

interface StateProps {
  notification: RootState['notification']
  answersUserId: number
  answersFormId: number
  hub: HubItem
}

interface DispatchProps {
  hideNotification: (reason: string) => void
  navigateToAnswers: (hubItem: HubItem) => void
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface OwnProps {}

type AnswersNotificationProps = StateProps & DispatchProps & OwnProps

function mapStateToProps(state: RootState): StateProps {
  return {
    notification: state.notification,
    answersUserId: userIdFromAnswersHubSelector(state),
    answersFormId: formIdFromAnswersHubSelector(state),
    hub: notificationHubSelector(state)
  }
}

function mapDispatchToProps(dispatch): DispatchProps {
  return {
    hideNotification: (reason: string) => dispatch(preHideNotification(reason)),
    navigateToAnswers: (hubItem: HubItem) => {
      dispatch(changeNavigationStack(createHubItemId(hubItem)))
      dispatch(navigateTo('answers', 'answersSearchResults', {}))
    }
  }
}

interface AnswersNotificationState {
  isOpened: boolean
}

class AnswersNotificationComponent extends React.Component<
  AnswersNotificationProps,
  AnswersNotificationState
> {
  handleAfterSearch = () => {
    this.props.hideNotification('answersSearch')
    this.props.navigateToAnswers(this.props.hub)
  }

  closeNotification = () => {
    this.props.hideNotification('close')
  }

  handleCloseKeyDown = (e: React.KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      this.props.hideNotification('close')
    }
  }

  getHtmlContent = () => {
    return {
      __html: linkifyHtml(this.props.notification.message, LINKIFY_OPTIONS)
    }
  }

  render() {
    const hasMessage = !!this.props.notification.message
    return (
      <div
        ref={(node) => resizingComponent.setRef(node, 'notification')}
        className={
          'imbox-answers-notification ' +
          (hasMessage ? 'hasMessage' : 'noMessage')
        }
      >
        <div className='imbox-proactive-message-wrapper'>
          <div className='imbox-proactive-message-body'>
            <div className='imbox-proactive-message-header'>
              {hasMessage && (
                <div
                  className='message'
                  dangerouslySetInnerHTML={this.getHtmlContent()}
                />
              )}

              <span
                className='notification-close'
                // eslint-disable-next-line react/jsx-handler-names
                onClick={this.closeNotification}
                role='button'
                onKeyDown={this.handleCloseKeyDown}
                tabIndex={0}
                aria-label={strings.a11yNotificationClose}
              >
                <i className='material-icons'>keyboard_arrow_down</i>
              </span>
            </div>

            <SearchField
              userId={this.props.notification.userId}
              answersId={this.props.notification.formId}
              // eslint-disable-next-line react/jsx-handler-names
              afterSearch={this.handleAfterSearch}
              shouldShowResults={false}
              shouldShowSuggestions={false}
            />
          </div>
        </div>
      </div>
    )
  }
}

const AnswersNotification = connect<StateProps, DispatchProps, OwnProps>(
  mapStateToProps,
  mapDispatchToProps
)(AnswersNotificationComponent)

export { AnswersNotification }
